import { createResource } from './create-request'

export const CustomFilters = createResource('/api/customfilters')
